import { useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import usePageModal from 'features/Modal/hooks/usePageModal'
import { Link, useNavigate } from 'features/i18n/router'
import { useResponsive } from 'hooks'
import { EXTERNAL_PATH, ROUTE_PATH } from 'lib/paths'
import { SessionStorage } from 'lib/storage'
import { selectIsLoggedIn } from 'store/selectors'
import { MODAL_MODE } from '../config'

import { ExternalLink } from 'components'

import { LoginMethod } from '../LoginModal'
import './style.scss'

const SignUpModal = ({ location }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { isMobile } = useResponsive()
  const { generatePageModalUrl } = usePageModal()

  const isLoggedIn = useSelector(selectIsLoggedIn)

  useEffect(() => {
    if (!isLoggedIn) return

    if (window.opener && SessionStorage.authorizeWalletParams.get()) {
      navigate(ROUTE_PATH.AUTHORIZE_WALLET)
      return
    }

    navigate(ROUTE_PATH.HOME)
  }, [isLoggedIn])

  if (isLoggedIn) {
    return null
  }

  return (
    <div className="Modal__wrapper Modal__wrapper--auto-h SignUpModal">
      {isMobile && (
        <div className="Modal__header">
          <a
            className="Modal__header__close"
            onClick={() => navigate(location.pathname)}
          ></a>

          <Link to={ROUTE_PATH.HOME}>
            <img
              className="Header__yay_logo"
              src="/images/logotype.svg"
              alt="yay! logo"
            />
          </Link>
        </div>
      )}

      <div className="SignUpModal__panel">
        <div className="SignUpModal__panel__wrapper">
          <h3 className="SignUpModal__panel__h3">{t('common.sign_up')}</h3>

          <LoginMethod className="SignUpModal__panel__login-methods" />

          <div className="SignUpModal__panel__terms">
            <Trans i18nKey="sign_up.terms">
              <ExternalLink
                className="SignUpModal__panel__terms__a"
                href={EXTERNAL_PATH.TERM()}
              />
              <ExternalLink
                className="SignUpModal__panel__terms__a"
                href={EXTERNAL_PATH.POLICY()}
              />
            </Trans>
          </div>

          <div className="SignUpModal__panel__hr" />

          <div className="SignUpModal__panel__login">
            <Trans i18nKey="sign_up.go_to_login">
              <Link
                className="SignUpModal__panel__login__a"
                to={generatePageModalUrl(
                  MODAL_MODE.LOGIN,
                  {},
                  window.location.pathname
                )}
              />
            </Trans>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SignUpModal
